import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { useDispatch } from "react-redux";
import { RaydiumOffchainResponse } from "@bridgesplit/abf-sdk";

const RAYDIUM_TAG = "RaydiumList";
export const raydiumExternalApi = createApi({
    reducerPath: "raydiumExternalApi",
    tagTypes: [RAYDIUM_TAG],
    baseQuery: fetchBaseQuery({ baseUrl: "https://api-v3.raydium.io/" }),
    endpoints: (builder) => ({
        raydiumOffchain: builder.query<RaydiumOffchainResponse, { ids: string[] }>({
            providesTags: [RAYDIUM_TAG],
            query: ({ ids }) => ({
                url: "/pools/info/ids",
                method: "GET",
                params: { ids }
            })
        })
    })
});

export const { useRaydiumOffchainQuery } = raydiumExternalApi;

export function useRaydiumExternalApi() {
    const dispatch = useDispatch();
    return { resetRaydiumExternalApi: () => dispatch(raydiumExternalApi.util.invalidateTags([RAYDIUM_TAG])) };
}
